// extracted by mini-css-extract-plugin
export default {"latestarticles":"latestarticles__DmakX","container":"container__Dqe9+","postitem":"postitem__Rimkv"};